import { render, staticRenderFns } from "./emailPassAndCapcha.vue?vue&type=template&id=2b95efb1&scoped=true"
import script from "./emailPassAndCapcha.vue?vue&type=script&lang=js"
export * from "./emailPassAndCapcha.vue?vue&type=script&lang=js"
import style0 from "./emailPassAndCapcha.vue?vue&type=style&index=0&id=2b95efb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95efb1",
  null
  
)

export default component.exports